import { useState, useRef } from 'react'
import { FaPencilAlt, FaTrashAlt, FaExchangeAlt, FaClock, FaCheckCircle, FaTimesCircle, FaCheck, FaFlag, FaSpinner, FaDolly } from 'react-icons/fa'
import { FaMoneyBillWave } from 'react-icons/fa6'
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs'
import { FiUser, FiCalendar } from 'react-icons/fi'
import { GrDocumentConfig } from 'react-icons/gr'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import './ListBudgetRow.css'

import EditBudget from '../EditBudget'
import EditConfigBudget from '../DefaultConfig/EditConfigBudget'
import ProposalPDFContent from '../ProposalPDF/ProposalPDFContent'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import TimestampToString from '../../../shared/functions/TimestampToString'

const STATUS_BADGE = {
    'Aguardando Resposta': 'budget-status-aguardando',
    'Aprovada': 'budget-status-aprovada',
    'Reprovada': 'budget-status-reprovada',
}

const STATUS_ICON = {
    'Aguardando Resposta': FaClock,
    'Aprovada': FaCheckCircle,
    'Reprovada': FaTimesCircle,
}

const STATUS_OPTIONS = [
    { value: 'Aguardando Resposta', icon: FaClock },
    { value: 'Aprovada', icon: FaCheckCircle },
    { value: 'Reprovada', icon: FaTimesCircle },
]

function ListBudgetRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess, allowSellerSelect }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const { timeStampToDDMMAAAA } = TimestampToString()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditBudget, setModalEditBudget] = useState(false)
    const [budgetId, setBudgetId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [budgetCode, setBudgetCode] = useState("")

    /* -------------------- Configurar Proposta -------------------------- */
    const [modalConfigProposal, setModalConfigProposal] = useState(false)
    const [configBudgetId, setConfigBudgetId] = useState("")

    /* -------------------- Mudar Status -------------------------- */
    const [modalChangeStatus, setModalChangeStatus] = useState(false)
    const [statusItem, setStatusItem] = useState({})

    /* -------------------- Gerar Pedido -------------------------- */
    const [modalGenerateOrder, setModalGenerateOrder] = useState(false)
    const [generateOrderItem, setGenerateOrderItem] = useState({})

    /* -------------------- Gerar Proposta (PDF) -------------------------- */
    const [generatingPdfId, setGeneratingPdfId] = useState(null)
    const pdfWindowRef = useRef(null)

    function handleGenerateProposal(item) {
        const win = window.open('', '_blank')
        if (!win) {
            setFlashMessage('Permita pop-ups para gerar a proposta', 'error')
            return
        }
        win.document.write('<title>Gerando proposta...</title><body style="font-family:sans-serif;display:flex;align-items:center;justify-content:center;height:100vh;margin:0;color:#6b7280;">Gerando proposta...</body>')
        pdfWindowRef.current = win
        setGeneratingPdfId(item._id)
    }

    async function deleteBudget(id) {
        let msgType = 'success'
        const data = await api.delete(`/order/budget/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    async function changeStatus(id, status) {
        let msgType = 'success'
        const data = await api.patch(`/order/budget/statusChange/${id}`, { status }, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            setModalChangeStatus(false)
            handleOnSuccess()
        }
    }

    async function generateOrder(id) {
        let msgType = 'success'
        const data = await api.patch(`/order/generate/${id}`, {}, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            setModalGenerateOrder(false)
            handleOnSuccess()
        }
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <div className='budget-row-text'>
                            <div className='budget-row-header'>
                                <span className='budget-row-code'>#{item.code}</span>
                                <span className='budget-row-name'>{item.client?.name}</span>
                            </div>
                            <div className='budget-row-links'>
                                {item.createdAt && (
                                    <span className='budget-row-link-item'><FiCalendar size={11} />{timeStampToDDMMAAAA(item.createdAt)}</span>
                                )}
                                {item.seller?.name && (
                                    <span className='budget-row-link-item'><FiUser size={11} />{item.seller.name}</span>
                                )}
                                {item.paymentMethod?.label && (
                                    <span className='budget-row-link-item'>{item.paymentMethod.label}</span>
                                )}
                                {item.orderPrice && (
                                    <span className='budget-row-price'><FaMoneyBillWave size={11} />R$ {item.orderPrice}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {item.status && (() => {
                        const StatusIcon = STATUS_ICON[item.status] || FaClock
                        return (
                            <div className="budget-status-col">
                                <span className="budget-status-caption"><FaFlag size={9} />Status</span>
                                <span className={`budget-status-badge budget-status-badge-lg ${STATUS_BADGE[item.status] || 'budget-status-aguardando'}`}>
                                    <StatusIcon size={12} />
                                    {item.status}
                                </span>
                            </div>
                        )
                    })()}

                    <div className='shd-row-box-item-action'>
                        {generatingPdfId === item._id ? (
                            <FaSpinner className='shd-icon-row-proposal shd-icon-spin' title='Gerando proposta...' />
                        ) : (
                            <BsFillFileEarmarkPdfFill className='shd-icon-row-proposal' title='Gerar Proposta' onClick={() => handleGenerateProposal(item)} />
                        )}
                        <GrDocumentConfig className='shd-icon-row-config' title='Configurar Proposta' onClick={() => { setConfigBudgetId(item._id); setModalConfigProposal(true) }} />
                        <div className='shd-icon-status-wrap' title='Alterar Status' onClick={() => { setStatusItem(item); setModalChangeStatus(true) }}>
                            <FaExchangeAlt className='shd-icon-status-exchange' />
                            <span className='shd-icon-status-badge'><FaFlag size={9} /></span>
                        </div>
                        {item.status === 'Aprovada' && (
                            <FaDolly className='shd-icon-row-generate' title='Gerar Pedido' onClick={() => { setGenerateOrderItem(item); setModalGenerateOrder(true) }} />
                        )}
                        {myPermissionEdit &&
                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setBudgetId(item._id); setModalEditBudget(true) }} />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setBudgetId(item._id); setBudgetCode(item.code) }} />
                        }
                    </div>
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditBudget}
                changeStatus={setModalEditBudget}
                t={1}
                w={98}
                h={97}
                content={
                    <EditBudget id={budgetId} handleOnSuccess={() => { setModalEditBudget(false); handleOnSuccess() }} btCancelAction={() => setModalEditBudget(false)} allowSellerSelect={allowSellerSelect} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteBudget(budgetId)}
                message="Deseja realmente excluir esse orçamento?"
                itemName={budgetCode && `#${budgetCode}`}
            />

            <Modal
                modalStatus={modalConfigProposal}
                changeStatus={setModalConfigProposal}
                w={80}
                t={2}
                content={
                    <EditConfigBudget id={configBudgetId} btCancelAction={() => setModalConfigProposal(false)} handleOnSuccess={() => setModalConfigProposal(false)} />
                }
            />

            <Modal
                modalStatus={modalChangeStatus}
                changeStatus={setModalChangeStatus}
                w={34}
                content={
                    <div className="bsp">
                        <div className="bsp-header">
                            <p className="bsp-title">Alterar Status da Proposta</p>
                            <span className="bsp-title-accent" />
                            <p className="bsp-subtitle">Selecione a nova situação de #{statusItem.code} - {statusItem.client?.name}.</p>
                        </div>
                        <div className="bsp-list">
                            {STATUS_OPTIONS.map(({ value, icon: Icon }) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={`bsp-pick ${STATUS_BADGE[value]} ${statusItem.status === value ? 'bsp-pick-active' : ''}`}
                                    onClick={() => changeStatus(statusItem._id, value)}
                                >
                                    <span className="bsp-pick-icon"><Icon size={16} /></span>
                                    <span className="bsp-pick-label">{value}</span>
                                    {statusItem.status === value && <FaCheck size={13} className="bsp-pick-check" />}
                                </button>
                            ))}
                        </div>
                    </div>
                }
            />

            <Modal
                modalStatus={modalGenerateOrder}
                changeStatus={setModalGenerateOrder}
                w={34}
                h={30}
                content={
                    <div className="bgp">
                        <div className="bgp-icon"><FaDolly size={24} /></div>
                        <p className="bgp-title">Gerar Pedido</p>
                        <p className="bgp-message">Deseja gerar o pedido a partir do orçamento #{generateOrderItem.code} - {generateOrderItem.client?.name}?</p>
                        <div className="bgp-actions">
                            <button type="button" className="bgp-btn bgp-btn-confirm" onClick={() => generateOrder(generateOrderItem._id)}>
                                <FaCheck size={16} /><span>Gerar Pedido</span>
                            </button>
                            <button type="button" className="bgp-btn bgp-btn-cancel" onClick={() => setModalGenerateOrder(false)}>
                                <FaTimesCircle size={18} /><span>Cancelar</span>
                            </button>
                        </div>
                    </div>
                }
            />

            {generatingPdfId && (
                <div className='pdf-hidden-render'>
                    <ProposalPDFContent
                        id={generatingPdfId}
                        onReady={(url) => {
                            if (pdfWindowRef.current) pdfWindowRef.current.location.href = url
                            setGeneratingPdfId(null)
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default ListBudgetRow
